import { BaseApi } from '@smorder/logic';

class AppApi extends BaseApi {
  * loadUiOptions() {
    return yield this.authorizedFetch('/api/v1/waiters/uioptions', {
      method: 'GET',
    });
  }
}

export default AppApi;
